import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface SewerOrSepticDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const SewerOrSepticDescription: React.FC<SewerOrSepticDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [sewerOrSeptic, set_sewerOrSeptic] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Major Systems']?.['Sewer or Septic']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems': { ...b.values?.['Major Systems'], 'Sewer or Septic': [v, b.values?.['Major Systems']?.['Sewer or Septic']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={sewerOrSeptic}
                />
            ) : (
                <TextBox
                    value={sewerOrSeptic}
                    onChange={(value) => set_sewerOrSeptic(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
